
import { Truck } from './types';

export const AVAILABLE_TRUCKS: Truck[] = [
  { id: 'TRK-001', name: 'Freightliner Cascadia #001', type: 'Heavy Duty', status: 'available' },
  { id: 'TRK-002', name: 'Volvo VNL 860 #002', type: 'Long Haul', status: 'available' },
  { id: 'TRK-003', name: 'Kenworth T680 #003', type: 'Medium Duty', status: 'available' },
  { id: 'TRK-004', name: 'Peterbilt 579 #004', type: 'Refrigerated', status: 'available' },
  { id: 'TRK-005', name: 'Mack Anthem #005', type: 'Flatbed', status: 'available' },
];

export const INITIAL_LOCATION = {
  lat: 28.6139,
  lng: 77.2090
};
